// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imgWithText-module--wrapper--3_cSq","contentOverlay":"imgWithText-module--contentOverlay--_3SG5"};